export const rateCheckTips = {
  question: 'What is Rate Check?',
  answer: 'Our Rate Check tool provides you with the average rate per mile '
  + 'for the lane you searched based on 7d, 15d,30d,60d, 90d or 365d. Rate Check can help you:',
};



// WEBPACK FOOTER //
// ./src/misc/QAdocument.js